import './App.scss';
import Footer from './components/Footer';
import Home from './components/Home';

function App() {
  return (
      <div className='App'>
        <Home />
        <Footer />
      </div>
  );
}

export default App;
